// ======================================================================
// File Name       : messageThread
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../../constants/actionTypes/messageThread';

export function receiveMessageList(resData, userListToStore) {
  return {
    type: ActionTypes.RECEIVE_MESSAGE_LIST,
    resData,
    userListToStore,
  };
}

export function addUsersToList(userListToAdd) {
  return {
    type: ActionTypes.ADD_USER_TO_LIST,
    userListToAdd,
  };
}

export function storeUserList(userSearchResult, groupRelationList, groupList) {
  return {
    type: ActionTypes.STORE_INIT_DATA,
    userSearchResult,
    groupRelationList,
    groupList,
  };
}

export function storeUserSearchResult(userSearchResult, newGroupRelationList) {
  return {
    type: ActionTypes.STORE_USER_SEARCH_RESULT,
    userSearchResult,
    newGroupRelationList,
  };
}

export function removeUserFromList(userSecernId) {
  return {
    type: ActionTypes.REMOVE_USER_FROM_LIST,
    userSecernId,
  };
}

export function resetEdittingUsers() {
  return {
    type: ActionTypes.RESET_EDITTING_USERS,
  };
}

export function receiveMessageInfo(
  messageInfo,
  rootMessageRelationList,
  userListToStore,
  groupRelationList,
  groupList,
  userListRecordNum,
) {
  return {
    type: ActionTypes.RECEIVE_MESSAGE_THREAD_INFO,
    messageInfo,
    rootMessageRelationList,
    userListToStore,
    groupRelationList,
    groupList,
    userListRecordNum,
  };
}

export function receiveMessageThreadUserPaging(
  rootMessageRelationList,
  userListToStore,
  groupRelationList,
  userListRecordNum,
) {
  return {
    type: ActionTypes.RECEIVE_MESSAGE_THREAD_USER_PAGING,
    rootMessageRelationList,
    userListToStore,
    groupRelationList,
    userListRecordNum,
  };
}

export function receiveInitDataForChat(structure, rootMessageInfo) {
  return {
    type: ActionTypes.RECEIVE_INIT_MESSAGE_STRUCTURE,
    structure,
    rootMessageInfo,
  };
}

export function receiveMessageStructure(structure) {
  return {
    type: ActionTypes.RECEIVE_MESSAGE_STRUCTURE,
    structure,
  };
}

export function loadMoreMessage() {
  return {
    type: ActionTypes.LOAD_MORE_MESSAGE,
  };
}

export function reloadChatAfterDelete(messageInfo) {
  return {
    type: ActionTypes.RELOAD_CHAT_AFTER_DELETE,
    messageInfo,
  };
}

